/**
 * 이름의 가운데 글자만 '*'로 마스킹하는 함수
 * @param {string} name - 마스킹할 이름
 * @returns {string} - 마스킹된 이름
 */
export const maskingName = (name) => {
  // 이름이 비어있거나 문자열이 아닌 경우
  if (!name || typeof name !== "string") {
    return name;
  }

  // 이름이 2글자 이하인 경우 마스킹 하지 않음
  if (name.length <= 2) {
    return name;
  }

  // 첫 글자와 마지막 글자를 제외한 모든 글자를 '*'로 변환
  const firstChar = name.charAt(0);
  const lastChar = name.charAt(name.length - 1);
  const middleChars = "*".repeat(name.length - 2);

  return firstChar + middleChars + lastChar;
};

/**
 * 전화번호에서 '010' 부분만 남기고 나머지를 '*'로 마스킹하는 함수
 * @param {string} phoneNumber - 마스킹할 전화번호
 * @returns {string} - 마스킹된 전화번호
 */
export const maskingPhoneNumber = (phoneNumber) => {
  // 전화번호가 비어있거나 문자열이 아닌 경우
  if (!phoneNumber || typeof phoneNumber !== "string") {
    return phoneNumber;
  }

  // 전화번호가 '010'으로 시작하는지 확인
  if (phoneNumber.startsWith("010")) {
    // 하이픈이 있는 경우와 없는 경우 모두 처리
    const digitsOnly = phoneNumber.replace(/-/g, "");

    // '010' 이후의 모든 숫자를 '*'로 변환
    const maskedPart = "*".repeat(digitsOnly.length - 3);

    // 원래 형식(하이픈 유무)에 따라 마스킹된 결과 반환
    if (phoneNumber.includes("-")) {
      // 하이픈이 있는 경우, 원래 형식 유지
      return "010-" + "*".repeat(phoneNumber.split("-")[1].length) + "-" + "*".repeat(phoneNumber.split("-")[2].length);
    } else {
      // 하이픈이 없는 경우
      return "010" + maskedPart;
    }
  }

  // '010'으로 시작하지 않는 경우, 전체 마스킹 처리
  return "*".repeat(phoneNumber.length);
};
